(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-story-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSection(root) {
    try {
      initSectionInner(root);
    } catch (err) {
      console.error('[shoppable-story-cards] failed to initialize:', err);
    }
  }

  function initSectionInner(root) {
    if (!root || root.dataset.ssInitialized) return;
    root.dataset.ssInitialized = 'true';

    var track = root.querySelector('[data-ss-track]');
    var initialCards = Array.prototype.slice.call(root.querySelectorAll('[data-ss-card]'));
    var prevBtn = root.querySelector('[data-ss-prev]');
    var nextBtn = root.querySelector('[data-ss-next]');
    var modal = root.querySelector('[data-ss-modal]');
    if (!track || !initialCards.length || !modal) return;

    var modalStage = modal.querySelector('[data-ss-modal-stage]');
    var modalClose = modal.querySelector('[data-ss-modal-close]');
    var modalMute = modal.querySelector('[data-ss-modal-mute]');
    var modalPrev = modal.querySelector('[data-ss-modal-prev]');
    var modalNext = modal.querySelector('[data-ss-modal-next]');
    var slides = Array.prototype.slice.call(modal.querySelectorAll('[data-ss-slide]'));
    var originalCardCount = initialCards.length;

        initialCards.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.dataset.ssClone = 'true';
      track.appendChild(clone);
    });

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ss-card]'));

        function playAllCardVideos() {
      root.querySelectorAll('[data-ss-card-video]').forEach(function (video) {
        video.muted = true;
        video.loop = true;
        if (video.paused) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
                            video.addEventListener('canplay', function retryPlay() {
                video.removeEventListener('canplay', retryPlay);
                video.play().catch(function () {});
              });
            });
          }
        }
      });
    }
    playAllCardVideos();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) playAllCardVideos();
    });

    var currentIndex = 0;
    var lastFocusedEl = null;
    var isDragging = false;
    var dragStartX = 0;
    var dragScrollStart = 0;
    var dragMoved = false;

        var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var marqueeSpeed = 0.45;     var marqueeHalfWidth = 0;
    var marqueeRafId = null;
    var isInteracting = false;     var isTouchingTrack = false;
    var isModalOpenFlag = false;

    function measureMarqueeWidth() {
      marqueeHalfWidth = track.scrollWidth / 2;
    }

    function marqueeTick() {
      var canAdvance = !prefersReducedMotion
        && !isDragging
        && !isInteracting
        && !isTouchingTrack
        && !isModalOpenFlag
        && marqueeHalfWidth > 0;

      if (canAdvance) {
        track.scrollLeft += marqueeSpeed;
        if (track.scrollLeft >= marqueeHalfWidth) {
          track.scrollLeft -= marqueeHalfWidth;
        }
      }
      marqueeRafId = window.requestAnimationFrame(marqueeTick);
    }

    function startMarquee() {
      measureMarqueeWidth();
      if (marqueeRafId) window.cancelAnimationFrame(marqueeRafId);
      marqueeRafId = window.requestAnimationFrame(marqueeTick);
    }

    track.addEventListener('mouseenter', function () { isInteracting = true; });
    track.addEventListener('mouseleave', function () { isInteracting = false; });
    track.addEventListener('focusin', function () { isInteracting = true; });
    track.addEventListener('focusout', function () { isInteracting = false; });
    track.addEventListener('touchstart', function () { isTouchingTrack = true; }, { passive: true });
    track.addEventListener('touchend', function () { isTouchingTrack = false; }, { passive: true });
    track.addEventListener('touchcancel', function () { isTouchingTrack = false; }, { passive: true });

        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragMoved = false;
      track.classList.add('is-dragging');
      dragStartX = e.pageX - track.offsetLeft;
      dragScrollStart = track.scrollLeft;
      e.preventDefault();
    });
    window.addEventListener('mouseup', function () {
      isDragging = false;
      track.classList.remove('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = x - dragStartX;
      if (Math.abs(walk) > 5) dragMoved = true;
      var next = dragScrollStart - walk;
            if (marqueeHalfWidth > 0) {
        next = ((next % marqueeHalfWidth) + marqueeHalfWidth) % marqueeHalfWidth;
      }
      track.scrollLeft = next;
    });

        function scrollByCard(direction) {
      var card = cards[0];
      var cardWidth = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var delta = direction * (cardWidth + gap);
      var next = track.scrollLeft + delta;
      if (marqueeHalfWidth > 0) {
        next = ((next % marqueeHalfWidth) + marqueeHalfWidth) % marqueeHalfWidth;
      }
      track.scrollTo({ left: next, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    function updateArrowVisibility() {
            if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = false;
      nextBtn.disabled = false;
    }
    updateArrowVisibility();
    window.addEventListener('resize', function () {
      updateArrowVisibility();
      measureMarqueeWidth();
    });

        function layout(activeIndex, animate) {
      var slideEl = slides[activeIndex];
      var baseWidth = slideEl.getBoundingClientRect().width || 300;
      var step = baseWidth * 0.62;

      slides.forEach(function (slide, i) {
        var diff = i - activeIndex;
        var absDiff = Math.abs(diff);
        var scale, opacity, z;

        if (absDiff === 0) { scale = 1; opacity = 1; z = 30; }
        else if (absDiff === 1) { scale = 0.74; opacity = 1; z = 20; }
        else if (absDiff === 2) { scale = 0.55; opacity = 1; z = 10; }
        else { scale = 0.4; opacity = 0; z = 0; }

        var translateX = diff * step;
        slide.style.transition = animate === false
          ? 'none'
          : '';
        slide.style.transform = 'translate(-50%, -50%) translateX(' + translateX + 'px) scale(' + scale + ')';
        slide.style.opacity = opacity;
        slide.style.zIndex = z;
        slide.style.pointerEvents = absDiff > 2 ? 'none' : 'auto';
        slide.classList.toggle('is-active', absDiff === 0);

        var video = slide.querySelector('[data-ss-slide-video]');
        if (video) {
          if (absDiff === 0) {
            if (!video.src && video.getAttribute('src')) {  }
            video.muted = true;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        }
      });

      if (modalMute) {
        var activeVideo = slideEl.querySelector('[data-ss-slide-video]');
        modalMute.hidden = !activeVideo;
        if (activeVideo) {
          modalMute.setAttribute('aria-pressed', String(activeVideo.muted));
        }
      }

      currentIndex = activeIndex;
      if (modalPrev) modalPrev.disabled = activeIndex === 0;
      if (modalNext) modalNext.disabled = activeIndex === slides.length - 1;
    }

    function goTo(index) {
      if (index < 0 || index >= slides.length || index === currentIndex) return;
      layout(index, true);
    }

    function openModal(index) {
      lastFocusedEl = document.activeElement;
      isModalOpenFlag = true;
      modal.hidden = false;
      layout(index, false);
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });

            var scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.ssScrollY = String(scrollY);
      document.body.style.top = '-' + scrollY + 'px';
      document.documentElement.classList.add('ss-scroll-lock');
      document.body.classList.add('ss-scroll-lock');

      if (modalClose) modalClose.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      isModalOpenFlag = false;
      slides.forEach(function (slide) {
        var video = slide.querySelector('[data-ss-slide-video]');
        if (video) video.pause();
      });
      document.removeEventListener('keydown', onKeydown);
      setTimeout(function () {
        modal.hidden = true;
        document.documentElement.classList.remove('ss-scroll-lock');
        document.body.classList.remove('ss-scroll-lock');

                var scrollY = parseInt(document.body.dataset.ssScrollY || '0', 10);
        document.body.style.top = '';
        delete document.body.dataset.ssScrollY;
        window.scrollTo(0, scrollY);

        if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
          lastFocusedEl.focus();
        }
      }, 300);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowRight') {
        goTo(currentIndex + 1);
      } else if (e.key === 'ArrowLeft') {
        goTo(currentIndex - 1);
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    }

    function trapFocus(e) {
      var focusable = modal.querySelectorAll('button:not([hidden]):not([disabled]), a[href]:not([hidden])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    cards.forEach(function (card, index) {
      var storyIndex = index % originalCardCount;
      card.addEventListener('click', function () {
        if (dragMoved) { dragMoved = false; return; }
        openModal(storyIndex);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(storyIndex);
        }
      });
    });

    slides.forEach(function (slide, index) {
      slide.addEventListener('click', function (e) {
        if (index !== currentIndex) goTo(index);
      });
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target === modalStage) closeModal();
    });
    if (modalPrev) modalPrev.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (modalNext) modalNext.addEventListener('click', function () { goTo(currentIndex + 1); });

    if (modalMute) {
      modalMute.addEventListener('click', function () {
        var video = slides[currentIndex].querySelector('[data-ss-slide-video]');
        if (!video) return;
        video.muted = !video.muted;
        modalMute.setAttribute('aria-pressed', String(video.muted));
      });
    }

        var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;
    if (modalStage) {
      modalStage.addEventListener('touchstart', function (e) {
        touchActive = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      modalStage.addEventListener('touchend', function (e) {
        if (!touchActive) return;
        touchActive = false;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) goTo(currentIndex + 1);
          else goTo(currentIndex - 1);
        }
      }, { passive: true });
    }

        modal.querySelectorAll('[data-ss-slide-cta]').forEach(function (cta) {
      cta.addEventListener('click', function () {
        var variantId = cta.getAttribute('data-variant-id');
        if (!variantId) {
          window.location.href = cta.getAttribute('data-product-url') || '#';
          return;
        }
        cta.disabled = true;
        var original = cta.textContent;
        cta.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            cta.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              cta.textContent = original;
              cta.disabled = false;
            }, 1600);
          })
          .catch(function () {
            cta.textContent = 'Try again';
            cta.disabled = false;
          });
      });
    });

    window.addEventListener('resize', function () {
      if (!modal.hidden) layout(currentIndex, false);
    });

        startMarquee();
    window.addEventListener('load', function () {
      measureMarqueeWidth();
      playAllCardVideos();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ss-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Safety net in case this script (via {% javascript %}) runs before
  // the section markup is fully attached in edge cases/theme editor.
  window.addEventListener('load', initAll);

  // Re-init when Shopify theme editor injects/reorders sections
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-ss-section]');
    if (section) initSection(section);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
